"use strict";
import MotorReservas from "./new/motorReserva.js";
import { initReservePicker } from "./new/Reserve.astro_astro_type_script_index_0_lang.js"
import { language } from "./old/language.js";

class MotorReservasUI {
  motor
  langId = Liferay.ThemeDisplay.getLanguageId();

  constructor() {
    this.motor = new MotorReservas()
  }

  addActions() {
    const selectInputs = document.querySelectorAll(".select-input-viva");
    const nodesToExpand = [];
    selectInputs.forEach((selectInput) => {
      const selectItems = selectInput.querySelector(".select-items-viva");
      const height = selectItems?.scrollHeight;
      if (selectItems && height) {
        nodesToExpand.push({ node: selectInput, height });
      }
      selectItems?.setAttribute("style", "height: 0px;");
    });
    nodesToExpand.forEach(({ node, height }) => {
      const isMultiple = node.getAttribute("data-multiple") === "true";
      node.addEventListener("click", () => {
        const selectItems = node.querySelector(".select-items-viva");
        const selectInputContainer = node.querySelector(
          ".select-input-viva-container"
        );
        if (selectItems?.classList.contains("active")) {
          selectItems.setAttribute("style", "height: 0px;");
          setTimeout(() => {
            selectInputContainer?.classList.remove("active");
            selectItems.classList.remove("active");
          }, 100);
        } else {
          let paddingTop = 40;
          if (selectItems?.classList.contains("collapse-mode")) {
            paddingTop = -40;
          }
          const paddingBottom = 16;
          const totalHeight = height + paddingTop + paddingBottom;
          selectItems?.classList.add("active");
          selectInputContainer?.classList.add("active");
          if (isMultiple) {
            selectItems?.setAttribute(
              "style",
              `height: ${totalHeight + 20}px; max-height: ${totalHeight + 20}px;`
            );
          } else {
            selectItems?.setAttribute("style", `height: ${totalHeight}px;`);
          }
        }
      });
      const listItems = node.querySelectorAll("li");
      const ulSelectedItems = node.querySelector(".select-items-viva");
      listItems.forEach((li) => {
        li.addEventListener("click", (e) => {
          e.stopPropagation();
          const input = node.querySelector("input");
          if (input) {
            // if (isMultiple) {
            //   const multipleSelectedValues = ulSelectedItems?.getAttribute("data-multiple-selected-values") || "";
            //   const currentValues = multipleSelectedValues ? multipleSelectedValues.split(",").map((v) => v.trim()) : [];
            //   const liText = li.textContent.trim() || "";
            //   if (currentValues.includes(liText)) {
            //     const newValues = currentValues.filter((v) => v !== liText);
            //     ulSelectedItems?.setAttribute(
            //       "data-multiple-selected-values",
            //       newValues.join(", ")
            //     );
            //     li.classList.remove("selected");
            //   } else {
            //     currentValues.push(liText);
            //     ulSelectedItems?.setAttribute(
            //       "data-multiple-selected-values",
            //       currentValues.join(", ")
            //     );
            //     li.classList.add("selected");
            //   }
            // } else {
              input.value = li.textContent.trim() || "";
            // }
          }
          // if (isMultiple) return;
          const selectItems = node.querySelector(".select-items-viva");
          const selectInputContainer = node.querySelector(
            ".select-input-viva-container"
          );
          selectItems?.setAttribute("style", "height: 0px;");
          setTimeout(() => {
            selectItems?.classList.remove("active");
            selectInputContainer?.classList.remove("active");
          }, 100);
        });
      });
      // if (isMultiple) {
      //   const btnConfirm = node.querySelector(".btn-confirm-hours");
      //   btnConfirm?.addEventListener("click", (e) => {
      //     e.stopPropagation();
      //     const selectItems = node.querySelector(".select-items-viva");
      //     const selectInputContainer = node.querySelector(
      //       ".select-input-viva-container"
      //     );
      //     selectItems?.setAttribute("style", "height: 0px;");
      //     const input = node.querySelector("input");
      //     const multipleSelectedValues = selectItems?.getAttribute("data-multiple-selected-values") || "";
      //     if (input) {
      //       input.value = multipleSelectedValues;
      //     }
      //     setTimeout(() => {
      //       selectItems?.classList.remove("active");
      //       selectInputContainer?.classList.remove("active");
      //     }, 100);
      //   });
      // }
    });
    //------
    const selectInputs2 = document.querySelectorAll(".input-inner-select-viva");
    const nodesToExpand2 = [];
    selectInputs2.forEach((selectInput) => {
      const selectItems = selectInput.querySelector(".select-items-input-inner-viva");
      const height = selectItems?.scrollHeight;
      if (selectItems && height) {
        nodesToExpand2.push({ node: selectInput, height });
      }
      selectItems?.setAttribute("style", "height: 0px;");
    });
    nodesToExpand2.forEach(({ node }) => {
      node.addEventListener("click", () => {
        const selectItems = node.querySelector(".select-items-input-inner-viva");
        const selectInputContainer = node.querySelector(".input-inner-select-viva-container");
        if (selectItems?.classList.contains("active")) {
          selectItems.setAttribute("style", "height: 0px;");
          setTimeout(() => {
            selectInputContainer?.classList.remove("active");
            selectItems.classList.remove("active");
          }, 100);
        } else {
          const height = selectItems?.scrollHeight || 0;
          const paddingTop = 56;
          const paddingBottom = 16;
          const totalHeight = height + paddingTop + paddingBottom;
          selectItems?.classList.add("active");
          selectInputContainer?.classList.add("active");
          selectItems?.setAttribute("style", `height: ${totalHeight}px;`);
        }
      });
    });
    //---------------------------------------------------------------------


    const btnConfirmGuests = document.getElementById("btnConfirmGuests");
    btnConfirmGuests?.addEventListener("click", (e) => {
      e.preventDefault();
      if (huespedesContainer) {
        huespedesContainer.setAttribute("style", "height: 0px;");
        const selectInputContainer = document.querySelector(
          ".huespedes-select-container"
        );
        selectInputContainer?.classList.remove("active");
        huespedesContainer.classList.remove("active");
        syncGuestesUI.call(this);
      }
    });

    function syncGuestesUI() {
      const huespedesReservasSelect = document.getElementById(
        "huespedes-reserva-select"
      );
      //   const adultsValue = parseInt(
      //   adultsInput?.getAttribute("value") || "0",
      //   10
      // );
      const adultsValue = this.motor.getAdults()
      // const childrenValue = parseInt(
      //   childrenInput?.getAttribute("value") || "0",
      //   10
      // );
      const childrenValue = this.motor.getKids()
      if (adultsValue == 0) {
        huespedesReservasSelect?.setAttribute("value", ``);
        return;
      }
      if (huespedesReservasSelect) {
        
        if (childrenValue > 0) {
          huespedesReservasSelect.setAttribute(
            "value",
            `${adultsValue} ${language["adultos"][this.langId]}, ${childrenValue} ${language["ninos"][this.langId]}`
          );
        } else {
          huespedesReservasSelect.setAttribute(
            "value",
            `${adultsValue} ${language["adultos"][this.langId]}`
          );
        }
      }
    }

    const adultsInput = document.getElementById("adultsInput");
    function syncAdultsUI() {
      if (adultsInput) {
        // const currentValue = parseInt(
        //   adultsInput.getAttribute("value") || "0",
        //   10
        // );
        // if (currentValue > 0) {
        const valueToSet = this.motor.getAdults()
        if (valueToSet == 0) {
          adultsInput.setAttribute("value", "");
        } else {
          adultsInput.setAttribute("value", valueToSet.toString());
        }
        syncGuestesUI.call(this);
        // }
      }
    }
    $("#adultsButtonAdd").on("click", () => {
      this.motor.incrementarAdults();
      syncAdultsUI.call(this);
      //syncGuestesUI.call(this);
    });

    $("#adultsButtonSubstract").on("click", () => {
      this.motor.decrementarAdults();
      syncAdultsUI.call(this);
      //syncGuestesUI.call(this);
    });

    $(".hotel-reserva-select-list li").on("click", (event) => {
      this.motor.cambioHotel($(event.currentTarget).data("value"));
      syncAdultsUI.call(this);
      syncChildrenUI.call(this);
        const hotelInput = document.getElementById("hotel-reserva-select");
        if (hotelInput) hotelInput.removeAttribute('style');
      //syncGuestesUI.call(this);
    });
    const childrenButtonAdd = document.getElementById("childrenButtonAdd");
    const childrenButtonSubstract = document.getElementById("childrenButtonSubstract");
    const childrenInput = document.getElementById("childrenInput");
    const kidsAgesContainer = document.getElementById("kidsAgesContainer");
    const nodeAgeKidInput = document.querySelector(".ageKidInputHidden");

    function syncChildrenUI() {
      const kids = this.motor.getKids();

      // 1. Sincronizar input
      if (childrenInput) {
        childrenInput.value = kids > 0 ? kids.toString() : "";
      }

      // 2. Ajustar número de inputs de edad
      if (kidsAgesContainer && nodeAgeKidInput) {
        // Si hay más nodos de los necesarios → eliminar
        while (kidsAgesContainer.childElementCount - 1 > kids) {
          kidsAgesContainer.removeChild(kidsAgesContainer.lastElementChild);
          // huespedesContainer?.setAttribute(
          //   "style",
          //   `height: ${huespedesContainer?.clientHeight - 52}px;`
          // );
        }

        // Si hay menos nodos de los necesarios → añadir
        while (kidsAgesContainer.childElementCount - 1 < kids) {
          const newNode = nodeAgeKidInput.cloneNode(true);
          newNode.classList.remove("hidden", "ageKidInputHidden");

          const newIndex = kidsAgesContainer.childElementCount + 1;

          // Actualizar el ID del div padre
          //id original ageKidInput
          newNode.setAttribute("id", `ageKidInputContainer${newIndex - 1}`);
          newNode.setAttribute(
            "placeholder",
            `${language["edad-nino"][this.langId]} ${newIndex - 1}`
          );

          // Actualizar el input interno (el que tiene la clase kidsAgeSelectContainer)
          const inputElement = newNode.querySelector(".kidsAgeSelectContainer");
          if (inputElement) {
            inputElement.setAttribute(
              "placeholder",
              `${language["edad-nino"][this.langId]} ${newIndex - 1}`
            );
            inputElement.setAttribute("id", `ageKidInput${newIndex - 1}`);
          }

          kidsAgesContainer.appendChild(newNode);
          // huespedesContainer?.setAttribute(
          //   "style",
          //   `height: ${huespedesContainer?.clientHeight + 52}px;`
          // );
        }
        if (kids > 0)
          huespedesContainer?.setAttribute(
            "style",
            `height: min-content;
            max-height: 52vh`

          );
        //TODO fix temporal del tamaño del container  
        kidsAgesContainer?.setAttribute(
          "style",
          `height: 12vh;`
        );
        //max-height: ${huespedesContainer?.clientHeight + 358}px;
        //50vp
        syncGuestesUI.call(this);
      }
    }



    const parseAgesString = (agesString) => agesString.split(';').filter(age => age.trim());


    //     kidsAgesContainer?.addEventListener("input", (e) => {
    //   if (e.target.classList.contains("kidsAgeSelectContainer")) {
    //     //e.target.value = e.target.value.replace(/[^\d]/g, '');
    //     if (!/[0-9]/.test(e.key)) {
    //       e.preventDefault();
    //     }
    //   }
    // });
    // Bloquear caracteres NO numéricos ANTES de que se escriban
    kidsAgesContainer?.addEventListener("keypress", (e) => {
      if (e.target.classList.contains("kidsAgeSelectContainer")) {
        // Solo permite números (0-9)
        if (!/[0-9]/.test(e.key)) {
          e.preventDefault();
        }
      }
    });

    // Bloquear copiar/pegar valores inválidos
    kidsAgesContainer?.addEventListener("paste", (e) => {
      if (e.target.classList.contains("kidsAgeSelectContainer")) {
        e.preventDefault();
        const pastedText = (e.clipboardData || window.clipboardData).getData('text');
        const numericOnly = pastedText.replace(/[^\d]/g, '');
        e.target.value = numericOnly;
      }
    });

    kidsAgesContainer?.addEventListener("change", (e) => {
      if (e.target.classList.contains("kidsAgeSelectContainer")) {
        handleKidsAgeSelectChange.call(this, e);
      }
    });


    function handleKidsAgeSelectChange(e) {
      const ages = parseAgesString(this.motor.getAges());

      // Obtener la posición del ID: "ageKidInput1" → 1
      var kidsSelect = e.target.id;
      var match = kidsSelect.match(/^ageKidInput(\d+)$/);
      var pos = match ? parseInt(match[1], 10) : 0;
      let value = parseInt(e.target.value) || 0;
           if (value < 0) value = 0;
           if (value > 12) value = 12;
          e.target.value = value;
      if (pos > 0) {
        ages[pos - 1] = e.target.value;
        this.motor.setAges(ages.join(';'));
      }
    }
    // Eventos
    childrenButtonAdd?.addEventListener("click", (e) => {
      e.preventDefault();
      this.motor.incrementarKids();
      syncChildrenUI.call(this);

      //buscar !bg-neutral-000
      //syncGuestesUI.call(this);
    });

    childrenButtonSubstract?.addEventListener("click", (e) => {
      e.preventDefault();
      this.motor.decrementarKids();
      syncChildrenUI.call(this);
      //syncGuestesUI.call(this);
    });
    //btnConsultarDisponibilidad
    $("#date-range-redesing").on("click", (e) => {
      $(e.currentTarget).removeAttr('style');
    });
    $("#btnConsultarDisponibilidad").on("click", async (e) => {
      //inputsReserveContainer

      if ($("#inputsReserveContainer").is(":visible")) {
        e.preventDefault();
        const errorCodes = await this.motor.handleSubmit();

        // Resetear colores previos
        const hotelInput = document.getElementById("hotel-reserva-select");
        const dateInput = document.getElementById("date-range-redesing");
        if (hotelInput) hotelInput.removeAttribute('style');
        if (dateInput) dateInput.removeAttribute('style');

        // Marcar en rojo los campos con errores
        if (Array.isArray(errorCodes) && errorCodes.length > 0) {
          errorCodes.forEach(errorCode => {
            if (errorCode === 1 && hotelInput) {
              hotelInput.setAttribute('style', 'border-color: red; color: red');
              hotelInput.parentElement?.setAttribute('style', 'border-color: red ;');
              // Forzar reflow para que el navegador redibuje inmediatamente
              void hotelInput.offsetHeight;
            } else if (errorCode === 3 && dateInput) {
              dateInput.setAttribute('style', 'border-color: red; color: red;');
              dateInput.parentElement?.setAttribute('style', 'border-color: red ;');
              // Forzar reflow para que el navegador redibuje inmediatamente
              void dateInput.offsetHeight;
            }
          });
        }
      }


    });
    //promotional-code-input
    $("#promotional-code-input").on("change", (e) => {
      e.preventDefault();
      this.motor.setCodPromo(e.target.value)
    })

    function openBookingtravel() {
      Analytics.track('MOTOR_RESERVAS_VUELO_HOTEL', {
        'origen': window.location.href,
        'idioma': Liferay.ThemeDisplay.getLanguageId()
      })
      window.open('https://bookingtravel.hotelsviva.com/' + Liferay.ThemeDisplay.getLanguageId().split("_")[0] + "/");

    }

    //    $("#hotelFlightReserve").on("click", openBookingtravel)
    document.querySelectorAll("#hotelFlightReserve").forEach(el => {
      el.addEventListener("click", openBookingtravel)
    })
    //autodetectar paguina del hotel
    const currentHotelId = document.getElementById('codHotel')?.textContent;
    //$(event.currentTarget).data("value")

    if (currentHotelId) {
      this.motor.cambioHotel(currentHotelId);
      
      // Actualizar el dropdown con el hotel seleccionado
      const hotelLi = document.querySelector(`.hotel-reserva-select-list li[data-value="${currentHotelId}"]`);
      if (hotelLi) {
        const hotelSelect = document.getElementById('hotel-reserva-select');
        if (hotelSelect) {
          hotelSelect.value = hotelLi.textContent.trim();
        }
      }
      
      syncAdultsUI.call(this);
      syncChildrenUI.call(this);
    }
    
  }

  genHtml() {
    const html = `
        <div class="fixed flex flex-col w-full bottom-0 z-50 reserve-card-container justify-end" id="reserveCardContainer">
    <div
      class="!px-6 sm:!px-0 flex flex-col justify-center self-end w-full z-30 transition-all duration-300 reserve-card"
      id="reserveCard22">
      <div
        class="more-info-reserve-card flex flex-col dt:flex-row gap-4 dt:gap-0 justify-between bg-neutral-000/80 !px-4 !pt-2 !pb-8 dt-sm:!px-4 dt-sm:!pb-14 w-[93%] relative -bottom-9 mx-auto rounded-t-2xl shadow-8xl dt:shadow-2xl">
        <div class="w-fit h-fit more-info-reserve-card-item">
          <a href="#"
            class="p-4 flex items-center gap-2 rounded-full cursor-pointer button-link-viva text-neutral-1000 leading-[120%] font-medium text-h5-sm movil-lg:text-h5-sm tb:text-h5-sm tb-lg:text-h5-md dt-sm:text-h5-md dt:text-h5-lg !gap-2 items-center !p-0 hover:text-viva-orange-600">
            <span class="iconViva icon-add-new !h-6 !w-6 bg-neutral-1000"></span>
            ${language["disfruta-ventajas-exclusivas"][this.langId]}

            <div class="!bg-viva-orange-600 hidden iconBgHover"></div>
          </a>

        </div>
        <div class="w-fit h-fit flex flex-row flex-wrap gap-6 items-center more-info-reserve-card-item">
          <a href="#"
            class="p-4 flex items-center gap-2 rounded-full cursor-pointer button-link-viva text-neutral-1000 leading-[120%] font-medium text-body-sm movil-lg:text-body-sm tb:text-body-sm tb-lg:text-body-md dt-sm:text-body-md dt:text-body-lg !gap-2 items-center !p-0 hover:text-viva-orange-600">
            <span class="iconViva icon-happy-smile !h-6 !w-6 bg-neutral-1000"></span>
            ${language["mejor-precio-online"][this.langId]}

            <div class="!bg-viva-orange-600 hidden iconBgHover"></div>
          </a>

          <a href="#"
            class="p-4 flex items-center gap-2 rounded-full cursor-pointer button-link-viva text-neutral-1000 leading-[120%] font-medium text-body-sm movil-lg:text-body-sm tb:text-body-sm tb-lg:text-body-md dt-sm:text-body-md dt:text-body-lg !gap-2 items-center !p-0 hover:text-viva-orange-600">
            <span class="iconViva icon-percentage !h-6 !w-6 bg-neutral-1000"></span>
            ${language["descuento-proximas-estancias"][this.langId]}

            <div class="!bg-viva-orange-600 hidden iconBgHover"></div>
          </a>

          <a href="#"
            class="p-4 flex items-center gap-2 rounded-full cursor-pointer button-link-viva text-neutral-1000 leading-[120%] font-medium text-body-sm movil-lg:text-body-sm tb:text-body-sm tb-lg:text-body-md dt-sm:text-body-md dt:text-body-lg !gap-2 items-center !p-0 hover:text-viva-orange-600">
            <span class="iconViva icon-upper-right-arrow !h-6 !w-6 bg-neutral-1000"></span>
            ${language["ventajas-programas-fidelizacion"][this.langId]}

            <div class="!bg-viva-orange-600 hidden iconBgHover"></div>
          </a>

        </div>
        <div class="flex dt:hidden flex-col pb-[1%] dt:pb-0">
          <div class="self-end block tb-lg:hidden">
            <a href="#" id="closeReserveCardFrame"
              class="p-4 flex items-center gap-2 rounded-full cursor-pointer button-link-viva w-max border text-label-lg border-neutral-800 rounded-full items-center !p-1 hover:bg-viva-orange-600 hover:border-viva-orange-600">
              <span class="iconViva icon-close !h-4 !w-4 bg-neutral-800"></span>


              <div class="undefined hidden iconBgHover"></div>
            </a>

          </div>
          <div class="flex flex-row items-start dt:items-end gap-1">
            <a href="#" id="hotelReserve"
              class="p-4 flex items-center gap-2 rounded-full cursor-pointer button-link-viva w-max text-viva-orange-500 border text-label-lg border-viva-orange-500 rounded-full items-center !p-1 hover:text-neutral-000 hover:bg-viva-orange-600 hover:border-viva-orange-600 btn-reserve-active btn-reserve-types">
              <span class="iconViva icon-bed !h-4 !w-4 bg-viva-orange-500"></span>
              <span class="custom-text-button reserve-text-active">${language["hotel"][this.langId]}</span>

              <div class="!bg-neutral-000 hidden iconBgHover"></div>
            </a>

            <a href="#" id="hotelFlightReserve"
              class="p-4 flex items-center gap-2 rounded-full cursor-pointer button-link-viva w-max text-viva-orange-500 border text-label-lg border-viva-orange-500 rounded-full items-center !p-1 hover:text-neutral-000 hover:bg-viva-orange-600 hover:border-viva-orange-600 btn-reserve-types">
              <span class="iconViva icon-plane !h-4 !w-4 bg-viva-orange-500"></span>
              <span class="custom-text-button reserve-text-active w-full">${language["vuelo-hotel"][this.langId]}</span>

              <div class="!bg-neutral-000 hidden iconBgHover"></div>
            </a>

          </div>
        </div>
      </div>
      <div
        class="z-10 bg-neutral-000 flex flex-col tb:flex-row w-[93%] mx-auto rounded-full !mb-4 !p-2 gap-2 justify-stretch shadow-8xl dt:shadow-2xl"
        id="reserveFrameCardViva">
        <div class="hidden dt:flex flex-col items-start dt:items-end gap-1 !pl-4">
          <a href="#" id="hotelReserve"
            class="p-4 flex items-center gap-2 rounded-full cursor-pointer button-link-viva w-max text-viva-orange-500 border text-label-lg border-viva-orange-500 rounded-full items-center !p-1 hover:text-neutral-000 hover:bg-viva-orange-600 hover:border-viva-orange-600 btn-reserve-active btn-reserve-types">
            <span class="iconViva icon-bed !h-4 !w-4 bg-viva-orange-500"></span>
            <span class="custom-text-button reserve-text-active">${language["hotel"][this.langId]}</span>

            <div class="!bg-neutral-000 hidden iconBgHover"></div>
          </a>

          <a href="#" id="hotelFlightReserve"
            class="p-4 flex items-center gap-2 rounded-full cursor-pointer button-link-viva w-max text-viva-orange-500 border text-label-lg border-viva-orange-500 rounded-full items-center !p-1 hover:text-neutral-000 hover:bg-viva-orange-600 hover:border-viva-orange-600 btn-reserve-types">
            <span class="iconViva icon-plane !h-4 !w-4 bg-viva-orange-500"></span>
            <span class="custom-text-button reserve-text-active w-full">${language["vuelo-hotel"][this.langId]}</span>

            <div class="!bg-neutral-000 hidden iconBgHover"></div>
          </a>

        </div>
        <div class="flex flex-row gap-2 w-full" id="inputsReserveContainer">
          <div class="w-full h-auto container-hotel-reserva-select">

            <div class="select-input-viva relative h-full" data-multiple="false">
              <div
                class="flex gap-2 border border-neutral-500 rounded-full !p-4 items-center relative z-20 select-input-viva-container  h-full hotel-reserva-select-container">
                <span class="iconViva icon-house !w-4 !h-4 bg-neutral-800"></span>
                <div class="flex flex-col gap-0.5 w-full">
                  <label for="hotel-reserva-select"
                    class="text-neutral-800 text-label-sm tb:text-label-md dt:text-label-lg font-gotham-book leading-[100%]">

                  </label>
                  <input type="text" placeholder="${language["seleccionar-hotel"][this.langId]}" id="hotel-reserva-select" readonly="true"
                    class="w-full !outline-none text-neutral-800 text-body-lg font-gotham-book leading-[120%]">
                </div>
                <span class="iconViva icon-down-arrow !w-4 !h-4 bg-neutral-800"></span>
              </div>
              <ul
                class="absolute flex-col w-full z-10 left-0 top-0 bg-neutral-000 rounded-t-2xl rounded-md shadow-lg select-items-viva gap-2 hotel-reserva-select-list"
                data-multiple-selected-values="">
                <li data-value="mesquidaresort"
                  class="rounded-md cursor-pointer w-full text-button-md leading-[24px] font-medium text-neutral-800 hover:text-viva-orange-600">
                  VIVA Cala Mesquida Resort &amp; Spa
                </li>
                <li data-value="vivablue"
                  class="rounded-md cursor-pointer w-full text-button-md leading-[24px] font-medium text-neutral-800 hover:text-viva-orange-600">
                  VIVA Blue &amp; Spa
                </li>
                <li data-value="sunrise"
                  class="rounded-md cursor-pointer w-full text-button-md leading-[24px] font-medium text-neutral-800 hover:text-viva-orange-600">
                  VIVA Sunrise
                </li>
                <li data-value="edenlago"
                  class="rounded-md cursor-pointer w-full text-button-md leading-[24px] font-medium text-neutral-800 hover:text-viva-orange-600">
                  VIVA Eden Lago
                </li>
                <li data-value="vanitygolf"
                  class="rounded-md cursor-pointer w-full text-button-md leading-[24px] font-medium text-neutral-800 hover:text-viva-orange-600">
                  VIVA Golf Adults Only +18
                </li>
                <li data-value="vanityhotel"
                  class="rounded-md cursor-pointer w-full text-button-md leading-[24px] font-medium text-neutral-800 hover:text-viva-orange-600">
                  VIVA Cala Mesquida Suites &amp; Spa +16
                </li>
                <li data-value="sonjaumell"
                  class="rounded-md cursor-pointer w-full text-button-md leading-[24px] font-medium text-neutral-800 hover:text-viva-orange-600">
                  Predi Son Jaumell Hotel Rural
                </li>

              </ul>
            </div>
          </div>
          <div class="w-full relative item-reserve h-14 tb-lg:h-auto contenedor-variable" id="parentElementoPicker">
            <div class="flex gap-2 border border-neutral-500 rounded-full !p-2 items-center bg-[transparent] h-full">
              <span class="iconViva icon-calendar !w-4 !h-4 bg-neutral-800"></span>
              <div class="flex flex-col gap-0.5 w-full">
                <label for="date-range-redesing"
                  class="text-neutral-800 text-label-sm tb:text-label-md dt:text-label-lg font-gotham-book leading-[100%]">

                </label>
                <input type="text" placeholder="${language["seleccione-fechas"][this.langId]}" id="date-range-redesing" readonly
                  class="w-full !outline-none text-neutral-800 text-body-lg font-gotham-book leading-[120%]">
              </div>
            </div>
          </div>
          <div class="w-full relative container-huespedes-reserva-select contenedor-variable">

            <div class="input-inner-select-viva relative h-full">
              <div
                class="flex gap-2 border border-neutral-500 rounded-full !p-2 items-center relative z-20 input-inner-select-viva-container  h-full huespedes-select-container">
                <span class="iconViva icon-user !w-4 !h-4 bg-neutral-800"></span>
                <div class="flex flex-col gap-0.5 w-full">
                  <label for="huespedes-reserva-select"
                    class="text-neutral-800 text-label-sm tb:text-label-md dt:text-label-lg font-gotham-book leading-[100%]">

                  </label>
                  <input type="text" placeholder="${language["adultos-ninos"][this.langId]}" id="huespedes-reserva-select" readonly="true"
                    class="w-full !outline-none text-neutral-800 text-body-lg font-gotham-book leading-[120%]">
                </div>
                <span class="iconViva icon-down-arrow !w-4 !h-4 bg-neutral-800"></span>
              </div>
              <div
                class="absolute flex-col w-full z-10 left-0 top-0 bg-neutral-000 rounded-t-2xl rounded-md shadow-lg select-items-input-inner-viva gap-2"
                id="huespedesContainer">
                <div>
                  <div class="flex flex-col !px-0 tb-lg:!px-2 !p-2 gap-2 rounded-lg overflow-y-auto max-h-[inherit]">
                    <div class="flex w-full gap-0.5">
                      <div
                        class="flex gap-2 border border-neutral-500 rounded-full !p-2 items-center !w-[inherit] adultsInput h-auto bg-neutral-000">
                        <span class="iconViva icon-user !w-4 !h-4 bg-neutral-800"></span>
                        <div class="flex flex-col gap-0.5 w-full">
                          <label for="adultsInput"
                            class="text-neutral-800 text-label-sm tb:text-label-md dt:text-label-lg font-gotham-book leading-[100%]">

                          </label>
                          <input type="text" placeholder="${language["adultos"][this.langId]}" id="adultsInput" readonly
                            class="w-full !outline-none text-neutral-800 text-body-lg font-gotham-book leading-[120%]">
                        </div>
                      </div>
                      <a href="#" id="adultsButtonAdd"
                        class="p-4 flex items-center gap-2 rounded-full cursor-pointer button-link-viva h-12 w-12 hover:bg-viva-orange-600 focus:bg-viva-orange-600">
                        <span class="iconViva icon-plus !h-6 !w-6 bg-neutral-800"></span>


                        <div class="!bg-neutral-000 hidden iconBgHover"></div>
                      </a>

                      <a href="#" id="adultsButtonSubstract"
                        class="p-4 flex items-center gap-2 rounded-full cursor-pointer button-link-viva h-12 w-12 hover:bg-viva-orange-600 focus:bg-viva-orange-600">
                        <span class="iconViva icon-substract !h-6 !w-6 bg-neutral-800"></span>


                        <div class="!bg-neutral-000 hidden iconBgHover"></div>
                      </a>

                    </div>
                    <div class="flex w-full gap-0.5">
                      <div
                        class="flex gap-2 border border-neutral-500 rounded-full !p-2 items-center !w-[inherit] childrenInput h-auto bg-neutral-000">
                        <span class="iconViva icon-reader !w-4 !h-4 bg-neutral-800"></span>
                        <div class="flex flex-col gap-0.5 w-full">
                          <label for="childrenInput"
                            class="text-neutral-800 text-label-sm tb:text-label-md dt:text-label-lg font-gotham-book leading-[100%]">

                          </label>
                          <input type="text" placeholder="${language["ninos"][this.langId]}" id="childrenInput" readonly
                            class="w-full !outline-none text-neutral-800 text-body-lg font-gotham-book leading-[120%]">
                        </div>
                      </div>
                      <a href="#" id="childrenButtonAdd"
                        class="p-4 flex items-center gap-2 rounded-full cursor-pointer button-link-viva h-12 w-12 hover:bg-viva-orange-600 focus:bg-viva-orange-600">
                        <span class="iconViva icon-plus !h-6 !w-6 bg-neutral-800"></span>


                        <div class="!bg-neutral-000 hidden iconBgHover"></div>
                      </a>

                      <a href="#" id="childrenButtonSubstract"
                        class="p-4 flex items-center gap-2 rounded-full cursor-pointer button-link-viva h-12 w-12 hover:bg-viva-orange-600 focus:bg-viva-orange-600">
                        <span class="iconViva icon-substract !h-6 !w-6 bg-neutral-800"></span>


                        <div class="!bg-neutral-000 hidden iconBgHover"></div>
                      </a>

                    </div>
                    <div id="kidsAgesContainer" class="flex flex-col gap-2 overflow-y-auto max-h-[100px]">
                      <div
                        class="flex gap-2 border border-neutral-500 rounded-full !p-2 items-center !w-[inherit] h-12 bg-neutral-000 hidden ageKidInputHidden">
                        <span class="iconViva icon-reader !w-4 !h-4 bg-neutral-800"></span>
                        <div class="flex flex-col gap-0.5 w-full">
                          <label for="ageKidInputToCopy"
                            class="text-neutral-800 text-label-sm tb:text-label-md dt:text-label-lg font-gotham-book leading-[100%]">

                          </label>
                          <input type="number" min="0" max="12" placeholder="${language["edad-nino"][this.langId]} 1" id="ageKidInputToCopy"
                            class="kidsAgeSelectContainer w-full !outline-none text-neutral-800 text-body-lg font-gotham-book leading-[120%]">
                        </div>
                      </div>
                    </div>
                    <div>
                      <a href="#" id="btnConfirmGuests"
                        class="p-4 flex items-center gap-2 rounded-full cursor-pointer button-link-viva w-full whitespace-nowrap justify-center h-full text-button-md !p-3 gap-2 bg-transparent text-neutral-800 border border-neutral-800 hover:bg-viva-orange-600 hover:text-neutral-000 hover:border-viva-orange-600">

                        ${language["confirmar-huespedes"][this.langId]}
                        <span class="iconViva icon-right-arrow !h-6 !w-6 bg-neutral-800"></span>
                        <div class="!bg-neutral-000 hidden iconBgHover"></div>
                      </a>

                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            class="w-full relative h-14 tb-lg:h-auto block tb-lg:hidden dt-sm:hidden dt:block contenedor-codigo-descuento contenedor-variable">
            <div class="flex gap-2 border border-neutral-500 rounded-full !p-2 items-center bg-[transparent] h-full">
              <span class="iconViva icon-shopping-tag !w-4 !h-4 bg-neutral-800"></span>
              <div class="flex flex-col gap-0.5 w-full">
                <label for="promotional-code-input"
                  class="text-neutral-800 text-label-sm tb:text-label-md dt:text-label-lg font-gotham-book leading-[100%]">

                </label>
                <input type="text" placeholder="${language["codigo-descuento"][this.langId]}" id="promotional-code-input"
                  class="w-full !outline-none text-neutral-800 text-body-lg font-gotham-book leading-[120%]">
              </div>
            </div>
          </div>
        </div>
        <div class="w-full tb:w-auto">
          <a href="#" id="btnConsultarDisponibilidad"
            class="p-4 flex items-center gap-2 rounded-full cursor-pointer button-link-viva w-full tb:w-32 dt:w-3xs justify-center h-full text-btn-md capitalize !p-4 gap-2 bg-viva-orange-500 text-neutral-000 hover:bg-viva-orange-600 hover:text-neutral-0 transition-colors duration-300">

            ${language["reservar"][this.langId]}
            <span class="iconViva icon-right-arrow !h-4 !w-4 bg-neutral-000"></span>
            <div class="!bg-neutral-000 hidden iconBgHover"></div>
          </a>

        </div>
      </div>
    </div>
  </div>

        `
    // <script type="module" src="./new/Reserve.astro_astro_type_script_index_0_lang.js"></script>
    return html;
    //       // test = (<div></div>)
    // // Insertamos el HTML en el body (o en el contenedor que quieras)
    // document.body.insertAdjacentHTML("beforeend", html);

    // // Creamos y cargamos el script como módulo
    // const script = document.createElement("script");
    // script.type = "module";
    // script.textContent = `
    //   import { saludar } from './saludos.js';
    //   saludar('Hola desde el módulo cargado por genHtml');
    // `;
    // document.body.appendChild(script);


  }
}


// var m = new MotorReservas()

// m.genHtml();
// m.addActions();
//nota una version que funciona es en la que al final del genHtml no se devuelve el html pero se genera del tiron
class WebComponent extends HTMLElement {
  constructor() {
    super();

    // // Creamos el contenedor raíz
    // const root = document.createElement('div');
    // root.setAttribute('class', 'portlet-container');

    // // Aquí insertamos el HTML generado por m.genHtml()
    // // Ojo: m.genHtml() debe devolver un string con HTML válido
    // var m = new MotorReservasUI()
    // root.innerHTML = m.genHtml();
    // m.addActions();
    // // Adjuntamos al shadow DOM
    // // this.attachShadow({ mode: 'open' }).appendChild(root);
    // this.appendChild(root)
  }

  async connectedCallback() {
    // // Instanciamos tu motor
    // const m = new MotorReservas();

    // // Insertamos el HTML generado dentro del shadowRoot
    // this.shadowRoot.innerHTML = m.genHtml();

    // // Enganchamos la lógica (listeners, etc.)
    // //m.addActions(this.shadowRoot);
    // m.addActions();
    const m = new MotorReservasUI();

    // Insertamos el HTML generado directamente en el propio elemento
    this.innerHTML = m.genHtml();

    // Enganchamos la lógica (listeners, etc.)
    m.addActions();
    // import("./new/Reserve.astro_astro_type_script_index_0_lang.js")

    initReservePicker()
  }

  // connectedCallback() {

  //       createRoot(this).render(
  //         <MotorBusqueda
  //         />,
  //         this
  //       );
  // }
}

const ELEMENT_ID = 'liferay-hoteles-viva-motor-reserva-redesign';

if (!customElements.get(ELEMENT_ID)) {
  customElements.define(ELEMENT_ID, WebComponent);
}
// import "./new/Reserve.astro_astro_type_script_index_0_lang.js"
